export const getAvailabilityStatus = (quantity: number | string) => {
  if (quantity === 'N/A') {
    return 'Out of Stock';
  }

  const qty = Number(quantity);

  if (Number.isNaN(qty) || qty <= 0) {
    return 'Out of Stock';
  } else if (qty <= 100) {
    return 'Low';
  } else {
    return 'High';
  }
};

export const availabilityColors: Record<string, string> = {
  'Out of Stock': '#F3EDE9',
  'Low': '#FFA500',
  'High': '#47C429',
  'N/A':'#CCECE8'
};

export const warehouseLocations: Record<string, string> = {
  SYD010: 'Sydney',
  AKL010: 'Auckland',
  AKL030: 'Auckland',
  AKL045: 'In New Zealand (ETA 4 weeks)',
  AKL046: 'In New Zealand (ETA 4 weeks)',
  AKLOTH: 'In New Zealand (ETA 12 working days)',
  BNE010: 'Brisbane',
  DAR010: 'Darwin',
  HES010: 'Hes',
  MEL010: 'Melbourne',
  NOR010: 'Adelaide',
  PER010: 'Perth',
};
export const stateDeafaultWarehouseLocations: Record<string, string> = {
  "nsw": "SYD010",
"act" : "SYD010",
"nt" : "DAR010",
"qld" : "BNE010",
"sa" : "MEL010",
"tas" : "MEL010",
"vic" : "MEL010",
"wa" : "PER010",
"SouthIsland" : "AKL010",
"NorthIsland" : "AKL010"
};



export const restrictedWarehouseCode = "AKLOTH";